module.exports = __webpack_public_path__ + "static/img/bg.48533e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg.jpg
// module id = eNLQ
// module chunks = 24